import { useEffect } from 'react'
import { useAuth } from '../../components/auth/AuthProvider'

/**
 * Visiting /logout runs logout (clears session and localStorage) and redirects to session-timeout.
 * No UI; runs on mount.
 */
export function LogoutPage() {
  const { signOut } = useAuth()
  useEffect(() => {
    signOut()
  }, [signOut])
  return null
}
